module.exports = __webpack_public_path__ + "img/flower.a1233027.png";